<template>
  <div class="registration-modal">

    <div class="modal-header">
      <h1 class="headline" v-text="$t('registration-modal-headline')"></h1>
      <h2 class="subheadline" v-if="false" v-text="$t('registration-modal-subheadline')"></h2>
    </div>
    <div class="modal-content">
      <ion-item v-if="!success">
        <div class="input-line">
          <div class="validation-errors" v-if="errors && errors.name">
            <span class="validation-error" v-for="error of errors.name" v-text="error" :key="error"></span>
          </div>

          <ion-input :label="$t('registration-modal-name-label')" label-placement="stacked" name="name" type="text"
            :placeholder="$t('registration-modal-name-placeholder')" v-model="name" :class="{
              'has-errors': errors && (errors.name || errors.global),
            }" />

        </div>
      </ion-item>

      <ion-item lines="none" v-if="!success">
        <div class="input-line">
          <div class="validation-errors" v-if="errors && errors.acceptedTerms">
            <span class="validation-error" v-for="error of errors.acceptedTerms" v-text="error" :key="error"></span>
          </div>
          <ion-checkbox slot="start" v-model="acceptedTerms" name="acceptedTerms" labelPlacement="end"
            v-html="$t('registration-modal-accept-terms-label')"></ion-checkbox>

        </div>
      </ion-item>
    </div>
    <div class="buttons">
      <ion-button class="note-button negative" color="dark" fill="clear" @click="cancel"
        v-text="$t('cancel-button-label')"></ion-button>
        <oido-button class="get-code-button"  @click="register" :show-spinner="processing" :primary="true"
      buttonStyle="solid" :label="$t('register-button-label')" ></oido-button>
    </div>
  </div>
</template>

<script setup>
import OidoButton from '../components/OidoButton.vue';
import {
  IonButton,
  modalController,
  IonCheckbox,
  IonInput,
  IonItem


} from "@ionic/vue";

import Validator from "validatorjs";
import customerService from "../composables/customerService";

</script>
<script>
export default {
  props: [],
  computed: {

  },
  data() {
    return {
      name: null,
      acceptedTerms: false,
      errors: {},
      success: false,
      processing: false
    }
  },

  methods: {
    cancel() {
      //get rid of the token in the url      
      customerService.removeTokenFromUrl()
      modalController.dismiss(false);
    },
    async register() {      
      this.errors = {}
      this.processing = true
      let rules = {
        acceptedTerms: "boolean|accepted",
        name: "present",
      }
      let data = {
        name: this.name,
        acceptedTerms: this.acceptedTerms
      }

      let validation = new Validator(data, rules);
      validation.setAttributeNames({
        name: this.$t("registration-modal-name-label"),
        acceptedTerms: this.$t("registration-modal-accepted-terms-error-field-name")
      });

      if (validation.fails()) {
        this.errors = validation.errors.errors
        this.processing = false
        return
      }


      let result = await customerService.completeRegistration(this.company.id, data)

      this.processing = false

      if (!result || result.errors) {
        if (result && result.errors) {
          // a correctable error occured
          this.errors = result ? result.errors : {}
        }else{
          //some other error occured
          this.cancel()
        }
      }
      modalController.dismiss(true);
    },
  },
}
</script>
<style scoped>
.registration-modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: white;
  padding: 2rem 3rem;
}

.registration-modal .modal-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
  text-align: center;
  width: 100%;
}

.registration-modal .modal-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  width: 100%;
}

.registration-modal .modal-header .headline {
  margin-top: 0;
  font-size: 1.2rem;
  margin-bottom: 0.3rem;

}

.registration-modal .modal-header .subheadline {
  margin-top: 0;
  font-size: 1rem;
  color: #666;

}

ion-item {
  margin-bottom: 2rem;
}

.input-line {
  width: 100%
}

ion-checkbox::part(label) {
  text-wrap: wrap;
}

.registration-modal .buttons {
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;

}

.registration-modal .buttons .oido-button, 
.registration-modal .buttons ion-button {
  margin: 0 0.5rem;
}
</style>
